import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

/** @category useFindIdRequestSms */
export type TypeRequestSmsParams = {
  /** 휴대전화 번호 */
  phoneNumber: string;
};

/** @category useFindIdRequestSms */
export type TypeRequestSmsResponse = {
  /** 응답 메시지 */
  message: string;
};

/**
 * @description 아이디 찾기 > 인증번호 요청 api 요청에 사용되는 커스텀 훅
 */
export const useFindIdRequestSms = () => {
  const { mutateAsync } = useMutation({
    mutationFn: (params: TypeRequestSmsParams) => {
      const endpoint = '/labor-accounts/phone-verification/for-find-username';
      return axiosInstance.post(endpoint, params, { headers: { withoutToken: true } });
    },
  });

  const requestFindIdRequestSms = async ({
    params,
    onSuccess,
    onError,
  }: {
    params: TypeRequestSmsParams;
    onSuccess?: (res: TypeRequestSmsResponse) => void;
    onError?: (err: TypeErrorFormat) => void;
  }) => {
    requestHelper(() => mutateAsync(params), onSuccess, onError);
  };

  return requestFindIdRequestSms;
};
